import { Base } from './base.model';
import { AccessLevel } from '../enums/access-level.enum';
import { deserialize, object, serializable } from 'serializr';
import { Entity } from './entity.model';

export class EntityAccess extends Base {
  @serializable
  public accessLevel: AccessLevel;
  @serializable(object(Entity))
  public entity: Entity;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(EntityAccess, input));
  }

  getAccessLevel(name) {
    return this.entity.name == name;
  }
}
